import type { InternalUrl } from '@tbitop/routing';
import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import { SegmentedController } from '../segmented-controller/segmented-controller';
import { Header1 } from '../typography/typography';

type ShellApplicationSingleContentProps = {
  applicationName: string;
  className?: string;
  headerId?: string;
};

export const ShellApplicationSingleContent = ({ applicationName, className, headerId, children }: PropsWithChildren<ShellApplicationSingleContentProps>) => (
  <div className={classNames(className, 'flex items-center')}>
    <Header1 className="flex-1" as="h1" id={headerId}>
      {applicationName}
    </Header1>
    {children}
  </div>
);

type Page = {
  name: string;
  href: string | InternalUrl;
  disabled?: boolean;
};

type ShellApplicationMultiContentProps = {
  pages: Page[];
  className?: string;
};

export const ShellApplicationMultiContent = ({ children, pages, className }: PropsWithChildren<ShellApplicationMultiContentProps>) => (
  <div className={classNames(className, 'flex items-center')}>
    <SegmentedController links={pages}/>
    {children}
  </div>
);
